import React from "react";
import { useContext, useEffect, useState } from "react";
import "../styling/NavigationBar.css";
import { Box, Button, Divider, Typography } from "@mui/joy";
import { AlertContext } from "../context/AlertFlag";
import { getVisitCapacity } from "../services/VisitCapacity";
import { get_user_subscription, post_subscription } from "../services/Subscription";
import UpgradeModal from "../components/modals/UpgradeModal";
import { useQuery } from "@tanstack/react-query";
import { get_user_account } from "../services/UserAccount";
import { daysFromNow } from "../utils/TimeConversion";


function HelpComponent() {
    const { addAlert } = useContext(AlertContext); 
    const [ userTier, setUserTier ] = useState(null);
    const [ userDays, setUserDays ] = useState(null);
    const [ userDaysLimit, setUserDaysLimit ] = useState(null);
    const [ openUpgrade, setOpenUpgrade ] = useState(false);

    const { data, isLoading, error } = useQuery({
        queryKey: ['user'],
        queryFn: get_user_account,
      })

    const getUserTier = async () => {
        try {
            const response = await get_user_subscription();
            setUserTier(response['tier']);
        } catch (error) {
            addAlert(error.message, "danger");
        }
    }

    const upgradePlan = () => {
        setOpenUpgrade(true);
    }

    const setClose = () => {
        setOpenUpgrade(false);
    }

    const handleBookSession = () => {
        window.open("https://calendly.com/d/cv2y-vng-7pq/abelscribe-demo", '_blank', 'noopener,noreferrer');
    }

    useEffect( () => {
        getUserTier();
    }, [])

    useEffect(() => {
        // How many days passed
        if (isLoading) {
            console.log("Loading user");
        } else {
            setUserDays(daysFromNow(data.created_at) > 14 ? 14 : daysFromNow(data.created_at));
            setUserDaysLimit(14);
        }
    }, [data])

    return (<div id="help-section">
        <div id="background-color">
            <UpgradeModal open={openUpgrade} setClose={setClose}/>
            <>
                <Typography level="title-md"> Help Desk </Typography>
                <Typography level="body-xs"> Need help getting set up or have questions? </Typography>
                <Typography level="body-xs"> Book a time with our team here: </Typography>
                <Button onClick={handleBookSession}> Book a session </Button>
            </>
            <Divider sx={{ my: 2 }} />
            {userTier === 'free' && <Box sx={{ justifyItems: "center", width: "100%" }}>
                <Typography level="title-md"> {userDays} / {userDaysLimit} </Typography>
                <Typography level="body-sm"> Days into your trial </Typography>
                <Button onClick={upgradePlan} sx={{ backgroundColor: "#2a3041", display: "flex" }}> Upgrade to Pro </Button>
            </Box>}
        </div>
      </div>)
}

export default HelpComponent